import styled from 'styled-components';

const JobEventLineNumber = styled.div`
  color: #161b1f;
  background-color: #ebebeb;
  flex: 0 0 45px;
  text-align: right;
  vertical-align: top;
  padding-right: 5px;
  border-right: 1px solid #d7d7d7;
  user-select: none;
`;

JobEventLineNumber.displayName = 'JobEventLineNumber';

export default JobEventLineNumber;
